import React from "react";

import moment from "moment";

import ZoomSelector from "./SchedulingZoomSelector";
import useTimebounds from "../../../hooks/useTimebounds";
import { getTimelinePeriod } from "../../../utils/fast";
import DateSelector from "../dateSelector/DateSelector";

import type { JSX } from "react";

interface DateSelectorLabelProps {
  displayedDate: string;
  displayedDay: string;
}

function DateSelectorLabel({
  displayedDate,
  displayedDay,
}: DateSelectorLabelProps): JSX.Element {
  return (
    <React.Fragment>
      <div>{displayedDate}</div>
      <div>{displayedDay}</div>
    </React.Fragment>
  );
}

enum DayClick {
  Previous = -1,
  Current = 0,
  Next = 1,
}

interface SchedulingDateSelectorProps {
  isEditMode: boolean;
}

export default function SchedulingDateSelector({
  isEditMode,
}: SchedulingDateSelectorProps): JSX.Element {
  const { timelineStartDate, timelineEndDate, updateTimebounds, currentDay } =
    useTimebounds();

  const handleDayClick = (day: DayClick): void => {
    const currentPeriod = getTimelinePeriod({
      startTime: timelineStartDate,
      endTime: timelineEndDate,
    });

    const newDay =
      day === DayClick.Current
        ? moment().startOf("hour").subtract(30, "minutes")
        : moment(currentDay).add(day, "days").startOf("day");

    const newStartTime = newDay.valueOf();
    const newEndTime = newDay.clone().add(currentPeriod, "minutes").valueOf();

    updateTimebounds({ startTime: newStartTime, endTime: newEndTime });
  };

  const displayedDate = moment(currentDay).format("DD/MM/YYYY");
  const displayedDay = moment(currentDay).format("dddd");

  return (
    <DateSelector
      currentDay={currentDay}
      onClickCurrent={(): void => handleDayClick(DayClick.Current)}
      onClickNext={(): void => handleDayClick(DayClick.Next)}
      onClickPrevious={(): void => handleDayClick(DayClick.Previous)}
      label={
        <DateSelectorLabel
          displayedDate={displayedDate}
          displayedDay={displayedDay}
        />
      }
    >
      <ZoomSelector isEditMode={isEditMode} />
    </DateSelector>
  );
}
